import React from "react";

import { createPortal } from "react-dom";
import styled from "styled-components";

interface AvatarFullscreenModalProps {
  avatar: string;
  alt?: string;
  onClose: () => void;
}

const Wrapper = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100vw; height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  z-index: 99999;
  display: flex; align-items: center; justify-content: center;
`;

export const AvatarFullscreenModal: React.FC<AvatarFullscreenModalProps> = ({
  avatar,
  alt = "Avatar",
  onClose,
}) => {
  if (typeof window === "undefined") return null;
  const modalRoot = document.getElementById("modal-container");
  if (!modalRoot) return null;

  return createPortal(
    <Wrapper onClick={onClose}>
      <img
        src={avatar}
        alt={alt}
        style={{
          borderRadius: "100%",
          width: "30rem",
          height: "30rem",
          objectFit: "cover",
        }}
      />
    </Wrapper>,
    modalRoot
  );
};
